<template>
  <div class="back">
    <div v-for="(item, ind) in orderListData" :key="ind" class="list_item">
      <div class="flex ai_center title_name">
        <div :class="item.show == 1 ? 'name_tag name_tag_s ' : 'name_tag name_tag_z '">
          <span>{{ item.show == 1 ?
            '申请换机' : "换机资料" }}</span>
        </div>
        <div class="order_time">
          {{ item.add_time }}
        </div>
        <div v-if="item.show == 1"
          :class="item.exa_status == 0 ? 'right_tag right_tag0' : item.exa_status == 1 ? 'right_tag right_tag1' : 'right_tag right_tag2'">
          {{ item.exa_status == 0 ? '申请待审核' : item.exa_status == 1 ? '申请成功' : '申请失败' }}
        </div>
        <div v-if="item.show == 2"
          :class="item.exa_status == 0 ? 'right_tag right_tag0' : item.exa_status == 1 ? 'right_tag right_tag1' : 'right_tag right_tag2'">
          {{ item.exa_status == 0 ? '换机待审核' : item.exa_status == 1 ? '换机成功' : '换机失败' }}

        </div>
      </div>
      <div class="itme_t">
        <div class="model_name flex flex_between ai_center">
          <div class="item_name">{{ item.model_name }}</div>
          <div class="item_btn" :class="item.prohibit === 1?'disabled':''" v-if="item.show == 1 && item.exa_status == 1"
            @click="goToChange(item)">
            上传换机完成资料
          </div>
          <div v-if="item.show == 2 && item.exa_status == 1" class="item_btn"
            @click="logisticsShow = true, logisticsItem = item">物流通知</div>
          <div class="item_btn" v-if="item.show == 2 && item.exa_status == 2" @click="goToChange(item)">
            修改资料
          </div>
        </div>
        <div class="item_text">IMEI：{{ item.imei }}</div>
        <div class="item_text" v-if="item.show == 2">支付状态：{{item.is_pay == 0?'待支付':item.is_pay == 1?'支付成功':'支付失败'}}</div>
        <div class="item_text"
          v-if="item.exa_status == 2">
          <div>驳回原因：</div>
          <div>{{ item.fail_exp }}</div>
        </div>
        <div class="item_text" v-if="item.exa_status == 1 && item.exa_status == 0">换机截止时间：{{ item.exp_time }}</div>
      </div>
    </div>
    <van-popup v-model="logisticsShow" closeable round class="logistics_popup">
      <div class="logistics_title flex flex_center">
        <div>
          <img src="../../assets/images/unicom/red_icon.png" alt="" style="width: 15px;height: 15px;">
          提示
        </div>
      </div>
      <div class="logistics_text">
        <div class="flex flex_center">快递小哥将【{{ logisticsItem.subscribeEndTime || '--' }}】来该门店取件</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  orderList
} from "@/api/unicom";

export default {
  name: "orderList",
  data() {
    return {
      orderListData: [],
      claimsList: [],
      finishList: [],
      logisticsShow: false,
      logisticsItem: {}
    }
  },
  mounted() {
    const queryData = JSON.parse(this.$route.query.data) || {}
    const { order_id } = queryData
    orderList({ order_id })
      .then((res) => {
        this.$toast((res && res.msg) || "获取数据成功");
        this.orderListData = res.data
      })
      .catch((err) => {
        this.$toast((err && err.msg) || "获取数据失败");
      });
  },
  methods: {
    goToChange(item) {
      const { claims_id, finish_id } = item
      this.$router.push({
        path: "/Unicom/change", query: {
          claims_id, finish_id
        }
      });

    }
  },
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}

.ai_center {
  align-items: center;
}

.flex_center {
  justify-content: center;
  align-items: center;
}

.flex_between {
  justify-content: space-between;
}

.back {
  padding: 30px 24px;
}

.logistics_popup {
  padding: 30px 48px 36px 48px;
  width: 600px;
  height: 330px;

  .logistics_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #333333;
    line-height: 44px;
  }

  .logistics_text {
    margin: 40px 0;
    text-align: center;
  }
}

.list_item {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 0 24px;
  margin-bottom: 24px;
  box-sizing: border-box;
  position: relative;

  .title_name {
    height: 76px;
    border-bottom: 1px solid #F0F1F4;
    display: flex;
    align-items: center;
    .name_tag {
      width: 88px;
      height: 32px;
      border-radius: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .name_tag_s {
      background-color: rgba(0, 128, 255, .1);
      color: #0080FF;
    }

    .name_tag_z {
      background-color: rgba(148, 77, 255, .1);
      color: #954EFF;
    }

    .order_time {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #AFAFAF;
      line-height: 34px;
    }

    .right_tag {
      position: absolute;
      padding-left: 12px;
      box-sizing: border-box;
      top: 1px;
      right: 1px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      line-height: 34px;
      width: 172px;
      height: 52px;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .right_tag0 {
      color: #FFA413;
      background-image: url(../../assets/images/unicom/right_tag0.png);

    }

    .right_tag1 {
      color: #34A855;
      background-image: url(../../assets/images/unicom/right_tag1.png);

    }

    .right_tag2 {
      color: #FF5D51;
      background-image: url(../../assets/images/unicom/right_tag2.png);
    }
  }

  .itme_t {
    padding: 20px 0;
    box-sizing: border-box;
    .model_name{
      margin-bottom: 12px;
    }
    .item_name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #333333;
      line-height: 44px;
    }

    .item_btn {
      height: 52px;
      background: #577bb5;
      border-radius: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 52px;
      padding: 0 12px;
      &.disabled{
        background: #c8c9cc;
      }
    }

    .item_text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      line-height: 34px;
      margin-bottom: 12px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

}
</style>
